import { fetchPost, fetchGet, rootApi } from '../helpers/api';

const historicalDataAPI = `${rootApi}/history-data`;

const deviceFaultSummaryAPI = `${rootApi}/getDeviceFaultSummary`;
const deviceFaultCountAPI = `${rootApi}/getDeviceFaultCount`;
const deviceFaultDetailsAPI = `${rootApi}/getDeviceFaultDetails`;
const stationDeviceFaultDeviceFaultAPI = `${rootApi}/getStationDeviceFaultDeviceList`;
const stationDeviceFaultDatesAPI = `${rootApi}/getStationDeviceFaultDateList`;
const qeuryDeviceFaultData = `${rootApi}/queryDeviceFaultData`;

export const loadYearIndices = () => fetchGet(`${historicalDataAPI}/year-indices`);

export const getStationDeviceFaultDeviceListInfo = stationDeviceFaultDeviceListInfo => fetchPost(stationDeviceFaultDeviceFaultAPI, stationDeviceFaultDeviceListInfo)
export const getStationDeviceFaultDatesInfo = stationDeviceFaultDatesInfo => fetchPost(stationDeviceFaultDatesAPI, stationDeviceFaultDatesInfo)
export const queryDeviceFaultData = requestData => fetchPost(qeuryDeviceFaultData, requestData)

export const getDeviceFaultSummary = deviceFaultSummary => fetchPost(deviceFaultSummaryAPI, deviceFaultSummary)
export const getDeviceFaultCount = deviceFaultCount => fetchPost(deviceFaultCountAPI, deviceFaultCount)
export const getDeviceFaultDetails = deviceFaultDetails => fetchPost(deviceFaultDetailsAPI, deviceFaultDetails)

